import { Data } from 'effect';

import { ErrorTag } from './index';

export class GetAuthTokenError extends Data.TaggedError(ErrorTag.AuthTokenGetError)<{
  message: string;
  cause?: unknown;
}> {}

export class SetAuthTokenError extends Data.TaggedError(ErrorTag.AuthTokenSetError)<{
  message: string;
  cause?: unknown;
}> {}

export class AuthTokenRefreshError extends Data.TaggedError(ErrorTag.AuthTokenRefreshError)<{
  message: string;
  cause?: unknown;
}> {}

export class JwtDecodeError extends Data.TaggedError(ErrorTag.JwtDecodeError)<{
  readonly token?: string;
  readonly cause?: unknown;
}> {
  override get message(): string {
    if (!this.cause) {
      return 'Failed to decode JWT token: Invalid format';
    }
    const causeMessage = this.cause instanceof Error ? this.cause.message : 'Unknown error';
    return `Failed to decode JWT token: ${causeMessage}`;
  }
}
